import { DefaultLayoutFeature, MyPagesLayoutFeature } from '@ori-appshell/layouts';
import { EditorialPageFeature } from '@ori/editorial-page';
const CommonPageFeatures = {
    ...EditorialPageFeature,
    /** It enable/disable sending search events to analytics. */ SendSearchEvents: '3767D0FE-0404-4FC8-A552-4B3F2A4036C7'
};
export const PageFeatures = {
    ...DefaultLayoutFeature,
    ...CommonPageFeatures
};
export const MyPagesPageFeatures = {
    ...MyPagesLayoutFeature,
    ...CommonPageFeatures
};
